import { ComponentProps, ForwardRefRenderFunction, ReactNode, forwardRef } from 'react';
import styled from 'styled-components';
import { DefaultLayoutPadding } from '../../../constants/Layout';
import { Screen, Spacing } from '../../../theme';
import FlexContainer from './FlexContainer';

export type FlexContainerProps = {
  children: ReactNode | ReactNode[];
  align?: string;
  justify?: string;
  gap?: Spacing;
  breaks?: Screen;
  padding?: Spacing;
  width?: string;
} & ComponentProps<'div'>;

const ConstrainedLayout = styled(FlexContainer)`
  min-width: 0;
  max-width: 100%;
`;

const LayoutFlexContainer: ForwardRefRenderFunction<HTMLDivElement, FlexContainerProps> = (
  { children, ...props },
  ref
) => {
  return (
    <ConstrainedLayout padding={DefaultLayoutPadding} gap="md" flexDirection="column" {...props} ref={ref}>
      {children}
    </ConstrainedLayout>
  );
};

export default forwardRef(LayoutFlexContainer);
